import { AUTH_TOKEN_STORAGE_KEYS } from '@auth/constants';


function getDeviceId() {
  return localStorage.getItem(AUTH_TOKEN_STORAGE_KEYS.DEVICE_ID);
}

function getAppToken() {
  return localStorage.getItem(AUTH_TOKEN_STORAGE_KEYS.APP_TOKEN);
}

function setAppToken(tokenValue) {
  localStorage.setItem(AUTH_TOKEN_STORAGE_KEYS.APP_TOKEN, tokenValue);
}

function removeAppToken() {
  localStorage.removeItem(AUTH_TOKEN_STORAGE_KEYS.APP_TOKEN);
}

function getUserRole() {
  const role = localStorage.getItem(AUTH_TOKEN_STORAGE_KEYS.USER_ROLE);
  try {
    return role ? JSON.parse(role) : null;
  } catch (e) {
    console.warn('Invalid role in localStorage', e);
    return null;
  }
}

function setUserRole(role) {
  localStorage.setItem(AUTH_TOKEN_STORAGE_KEYS.USER_ROLE, JSON.stringify(role));
}

const authTokenStorage = {
  getAppToken,
  setAppToken,
  removeAppToken,
  getDeviceId,
  getUserRole,
  setUserRole
};

export default authTokenStorage;